import { SERVER_URI } from '../Constant/server'
import { apiGet, apiPost, apiPost1, apiPut, apiPut1 } from '../utils/axios'

const MANAGER_CARD = SERVER_URI + '/create-manager-card';
const GET_MANAGER_CARD = SERVER_URI + '/get-manager-card';
const CHANGE_STATUS = SERVER_URI + '/change-status-manager-card/';
const UPDATE_MANAGER_CARD = SERVER_URI + '/update-manager-card/';





export default {

    createManager: async function (paylaod) {
        // console.log('ffff',paylaod);
        return apiPost(MANAGER_CARD, paylaod);
    },
    getManagerCard: async function (payload) {
        return apiGet(GET_MANAGER_CARD,payload);
    },
    changeStatusManager: async function (id) {
        return apiGet(CHANGE_STATUS + id)
    },
    updateManagerCard: async function (id, payload) {
        return apiPost(UPDATE_MANAGER_CARD + id, payload);

    }


}